import { Set } from 'immutable'
import { RxConversationAPI } from '@driftt/dapper'

function parseParticipants(data) {
  return Set(data.participants)
}

export const api = {
  fetch(conversationId) {
    return RxConversationAPI
      .get(`/conversations/${conversationId}/participants`)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(parseParticipants)
  },

  add({ conversationId, participants, teams }) {
    return RxConversationAPI
      .post(`/conversations/${conversationId}/participants`, { participants, teams })
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(parseParticipants)
  },

  remove(conversationId, participants) {
    return RxConversationAPI
      .delete(`/conversations/${conversationId}/participants`, { participants })
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(parseParticipants)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/participants/api.js